import { render } from "./FormPhotoGlases.vue?vue&type=template&id=74c3df9c"
import script from "./FormPhotoGlases.vue?vue&type=script&lang=js"
export * from "./FormPhotoGlases.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__